import "./supplychain.css";
import Footer from "../components/Footer.js";
import Navbar from "../components/Navbar.js";

const Security = () => {

  return (
    <div>
      <Navbar />
      <div className="spacer"></div>
      {/* Security Section */}
      <div className="supply-container">
        <div className="supply-header">
          <h1 className="supply-title">
            See risks before they <br />
            become Threats
          </h1>
          <p className="supply-description">
            We watch out, so you don’t have to worry. Our system uses smart
            monitoring and real-time data to help protect your team, your stuff,
            and the space around you.If something’s off, you’ll know right away.
            Plus, you get smart insights to help stop problems before they
            start. It’s like having a safety sidekick—keeping things safe,
            smooth, and stress-free.
          </p>
        </div>
      </div>

      <div className="containerSupply">
        <div className="image-sectionSupply">
          <img src="sevurity1.png" alt="Product Line" />
        </div>
        <div className="contentSupply">
          <h1>BOOST SAFETY PROTOCOL COMPILANCE BY 35%</h1>
          <hr style={{ maxWidth: "100%" }}></hr>
          <h4 style={{ fontWeight: "300" }}>
            Reduce the risk of non compliance fines by 30% with enhanced
            <br /> adherence strategies.
          </h4>
          <ul className="featuresSupply">
            <li>Monitor real-time, Safety compliance.</li>
            <li>Reduce the risk of costly accident and fines.</li>
          </ul>
        </div>
      </div>

      <div className="container">
        <div className="content">
          <h1>
            DECREASE THEFT INCIDENT BY 50% WITH REAL-TIME
            <br />
            MONITORING
          </h1>
          <hr style={{ maxWidth: "100%" }}></hr>
          <h4 style={{ fontWeight: "300" }}>
            Strengthen site security and protect assets with continuous
            <br /> surveillance.
          </h4>
          <ul className="features">
            <li>Smart vision to prevent theft.</li>
            <li>Ensure that workers & equipment are secure</li>
          </ul>
        </div>
        <div className="image-section">
          <img src="security2.png" alt="Product Line" />
        </div>
      </div>

      <div className="containerSupply">
        <div className="image-sectionSupply">
          <img src="security3.png" alt="Product Line" />
        </div>
        <div className="contentSupply">
          <h1>
            ENSURE A SAFE WORKPLACE WITH CONTINUOS
            <br /> MONITORING
          </h1>
          <hr style={{ maxWidth: "100%" }}></hr>
          <h4 style={{ fontWeight: "300" }}>
            Monitoring environmental parameters to maintain a healthy
            <br /> and secure working environment.
          </h4>
          <ul className="featuresSupply">
            <li>Continuously track environmental factors</li>
            <li>Ensure site compliance and safety</li>
          </ul>
        </div>
      </div>
<div>
</div>
      <Footer />
    </div>
  );
};

export default Security;
